// api
import {
  apiPostPdfMaterial,
  apiGetPdfMaterial
} from '@/services/API/pdf'

// utils
import downloadBlobFile from '@/utils/downloadBlobFile'
import requirePath from '@/utils/requirePath'

// components
import maInputText from '@/components/input/modules/text'
import maLoader from '@/components/loader'

// vuex
import { mapState, mapMutations } from 'vuex'

// types
import { WARRANTY_MODULE_NAME, UPDATE_LOADER } from '@/store/types'

/**
 * @module
 * @name materialSummary
 */
export default {
  name: 'materialSummary',
  /**
   * @property {String} email Used to store email input.
   * @property {Boolean} sendingMail Determines if the backend operation has
   *  answered yet and then show a spinner / loader.
   */
  data: function () {
    return {
      email: null,
      sendingMail: false
    }
  },
  components: {
    maInputText,
    maLoader
  },

  /**
   * @property {Boolean} validMail return RegExp test. True if it's and email.
   */
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyMaterialSummary: 'materialSummary'
    }),
    validMail: function () {
      return /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(this.email)
    }
  },
  methods: {
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),
    /**
     * @function
     * @name getImggPath
     * @param {String} img Image name
     * @description Returns resolved path, absolute to img file.
     */
    getImgPath (img) {
      try {
        return requirePath(img)
      } catch (error) {
        return requirePath('GAG_EMPTY.png')
      }
    },

    /**
     * @function
     * @name apiGetPdfMaterial
     * @description Get material PDF of proper stateWarrantySinisterId sinister.
     */
    getMaterialPdf: function () {
      this.updateLoader(true)
      apiGetPdfMaterial(this.stateWarrantySinisterId)
        .then(data => {
          downloadBlobFile(data, 'Material summary PDF.pdf')
          this.throwNotification(this.$t('notifications.pdfMaterial.title'), this.$t('notifications.pdfMaterial.body'), 'OK')
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.title'), this.$t('notifications.error.body'), 'KO')
        })
        .finally(() => { this.updateLoader(false) })
    },

    /**
     * @function
     * @name sendMail
     * @description Handler for posting an email send.
     */
    sendMail: function () {
      // eslint-disable-next-line
      if (this.validMail) {
        this.sendingMail = true
        apiPostPdfMaterial(this.stateWarrantySinisterId, this.email)
          .then(() => {
            this.throwNotification(this.$t('notifications.mailPdfMaterial.title'), this.$t('notifications.mailPdfMaterial.body'), 'OK')
          })
          .catch(() => {
            this.throwNotification(this.$t('notifications.error.title'), this.$t('notifications.error.body'), 'KO')
          })
          .finally(() => {
            this.sendingMail = false
          })
      } else {
        this.throwNotification(this.$t('notifications.mailPdfMaterial.error.title'), this.$t('notifications.mailPdfMaterial.error.body'), 'KO')
      }
    },
    /**
     * @function
     * @name closeModal
     * @description Hide modal.
     */
    closeModal: function () {
      this.$parent.$data.showModal = false
    }
  }
}
